import { WidgetQueryOptions } from 'app/modules/collection/services/filter.service';

interface ArticleData {
  headerData: any;
  contentData: any;
}

export abstract class Article {
  abstract transform(): ArticleData;

  constructor(
    public scene: string | undefined,
    public projectId: string,
    public collectionName: string,
    public analysisGroupId: string,
    public analysisId: string,
    public timezone: string,
    public documentQueryOptions: WidgetQueryOptions[],
    public reportData: any
  ) {}
}

export class SummarizeLatestArticle extends Article {
  transform(): ArticleData {
    const bucketedResponse = this.reportData.comparisonBuckets ?? [this.reportData];
    const lastBucketValues = bucketedResponse.map((bucket) =>
      Object.entries(bucket.items)
        .map(([key, value]) => ({ date: new Date(key).getTime(), values: (value as any).metadata }))
        .sort((d1, d2) => d1.date - d2.date)
        .pop()
    );

    const lastDateBucket = Math.max(...lastBucketValues.map((bv) => bv?.date ?? 0));
    if (!lastDateBucket) {
      return;
    }

    let values = lastBucketValues[0]?.values;
    if (bucketedResponse.length > 1) {
      // has multi-bucket comparison
      values = lastBucketValues.map((bv) => {
        if (bv?.date === lastDateBucket) {
          return bv.values[0];
        }
      });
    }

    for (const queryOptions of this.documentQueryOptions) {
      queryOptions.widgetContextMenu = {
        category: lastDateBucket,
        index: 0,
        series: {
          data: [],
        },
      };
    }

    return {
      headerData: lastDateBucket,
      contentData: values,
    };
  }
}
